import * as constants from './constants';

export const initialState = {
  loading: false,
  error: null,
  countries: [],
  currencies: [],
  insuranceCompanies: [],
  travelRisks: [],
  policyStatuses: [],
  paymentCashes: [],
  paymentOperations: [
    { id: constants.OPERATION_INCOME, name: 'Приход' },
    { id: constants.OPERATION_OUTCOME, name: 'Расход' },
  ],
  paymentTargets: [
    { id: constants.TARGET_PARTNER, name: 'Партнёр' },
    { id: constants.TARGET_CLIENT, name: 'Клиент' },
  ],
  paymentTypes: [],
};

const dictionariesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_COUNTRIES_FAIL:
    case constants.FETCH_COUNTRIES_SUCCESS:
    case constants.FETCH_CURRENCIES_FAIL:
    case constants.FETCH_CURRENCIES_SUCCESS:
    case constants.FETCH_INSURANCE_COMPANIES_FAIL:
    case constants.FETCH_INSURANCE_COMPANIES_SUCCESS:
    case constants.FETCH_TRAVEL_RISKS_FAIL:
    case constants.FETCH_TRAVEL_RISKS_SUCCESS:
    case constants.FETCH_POLICY_STATUSES_FAIL:
    case constants.FETCH_POLICY_STATUSES_SUCCESS:
    case constants.FETCH_PAYMENT_TYPES:
    case constants.FETCH_PAYMENT_TYPES_FAIL:
    case constants.FETCH_PAYMENT_TYPES_SUCCESS:
    case constants.FETCH_PAYMENT_CASHES:
    case constants.FETCH_PAYMENT_CASHES_FAIL:
    case constants.FETCH_PAYMENT_CASHES_SUCCESS:
    case constants.CREATE_PAYMENT_TYPE:
    case constants.CREATE_PAYMENT_TYPE_FAIL:
    case constants.CREATE_PAYMENT_TYPE_SUCCESS:
    case constants.UPDATE_PAYMENT_TYPE:
    case constants.UPDATE_PAYMENT_TYPE_FAIL:
    case constants.UPDATE_PAYMENT_TYPE_SUCCESS:
    case constants.DELETE_PAYMENT_TYPE:
    case constants.DELETE_PAYMENT_TYPE_FAIL:
    case constants.DELETE_PAYMENT_TYPE_SUCCESS:
    case constants.CREATE_PAYMENT_CASH:
    case constants.CREATE_PAYMENT_CASH_FAIL:
    case constants.CREATE_PAYMENT_CASH_SUCCESS:
    case constants.UPDATE_PAYMENT_CASH:
    case constants.UPDATE_PAYMENT_CASH_FAIL:
    case constants.UPDATE_PAYMENT_CASH_SUCCESS:
    case constants.DELETE_PAYMENT_CASH:
    case constants.DELETE_PAYMENT_CASH_FAIL:
    case constants.DELETE_PAYMENT_CASH_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default dictionariesReducer;
